/* eslint-disable */
import settings from "../../../configs/settings";
import { Autocomplete, Box, Paper, TextField, Typography, Fab, Tooltip } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { isNumeric } from "../../../project/utils/utils";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { getCacheData } from "../../services/CacheService";
//
// ################################################################################
//
const CobroTransferenciaBancaria = () => {
  const [valueACCuentaBancaria, setValueACCuentaBancaria] = useState({
    id: "",
    label: "",
  });
  const [inputValueACCuentaBancaria, setInputValueACCuentaBancaria] =
    useState("");

  const {
    setMessage,
    setShowMessage,
    handleChangeMedioDeCobro,
    limpiaMedioDeCobro,
    medioDeCobroAction,
    medioDeCobro,
    setMedioDeCobro,
    agregaMedioDeCobro,
    setExpandedAccordionMediosDeCobro,
    restoACobrar,
  } = useContext(CobranzaContext);
  const { idCuentaBancaria, bancoCuentaBancaria, comprobanteCuentaBancaria, importe } =
    medioDeCobro;
  const _importeAnterior = medioDeCobro.importe;
  const [cuentasBancarias, setCuentasBancarias] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadCuentasBancarias();
    setValueACCuentaBancaria({
      id: idCuentaBancaria,
      label: bancoCuentaBancaria,
    });
  }, []);
  //
  // ################################################################################
  //
  const loadCuentasBancarias = async () => {
    const response = await getCacheData("cuenta_bancaria");
    if (response.ok) {

      let _cuentasBancarias = [];
      let _cuentaBancaria = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion = item.banco.toUpperCase() + " - CBU: " + item.numero_cbu.toUpperCase();
        _cuentaBancaria = {
          id: item.id,
          idCuentaBancaria: item.id,
          bancoCuentaBancaria: _descripcion,
          label: _descripcion,
        };
        _cuentasBancarias.push(_cuentaBancaria);
      });
      setCuentasBancarias(_cuentasBancarias);
    } else {
      setCuentasBancarias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setMedioDeCobro({
      ...medioDeCobro,
      idCuentaBancaria: valueACCuentaBancaria.id,
      bancoCuentaBancaria: valueACCuentaBancaria.label,
    });
  }, [valueACCuentaBancaria]);
  //
  // ################################################################################
  //
  const cancelaCobro = () => {
    limpiaMedioDeCobro();
    setExpandedAccordionMediosDeCobro(false);
  };
  //
  // ################################################################################
  //
  const actualizaCobro = () => {
    // valido los datos del cobro

    if (inputValueACCuentaBancaria === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una Cuenta Bancaria",
      });
      setShowMessage(true);
      return;
    }

    if (comprobanteCuentaBancaria === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de comprobante de la transferencia",
      });
      setShowMessage(true);
      return;
    }

    if (typeof importe === "string") {
      if (!isNumeric(importe)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe mayor a 0",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+importe <= 0) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar un importe mayor a 0",
      });
      setShowMessage(true);
      return;
    }

    if (
      +importe >
      (medioDeCobroAction.cu === "new" ? restoACobrar : restoACobrar + _importeAnterior)
    ) {
      setMessage({
        severity: "error",
        messageText: "El importe cobrado debe ser menor o igual al resto a cobrar",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el medio de cobro a la tabla de medios de cobro

    agregaMedioDeCobro("transferencia-bancaria");
  };
  //
  // ################################################################################
  //
  const asignaRestoACobrar = () => {
    setMedioDeCobro({
      ...medioDeCobro,
      importe: restoACobrar,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ mt: 1, p: 2 }}>
        <Typography component={"span"} variant={"body1"}>
          Transferencia Bancaria
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Autocomplete
            id="cuentaBancariaOptions"
            size="small"
            value={valueACCuentaBancaria}
            onChange={(event, newValue) => {
              setValueACCuentaBancaria(newValue);
            }}
            inputValue={inputValueACCuentaBancaria}
            onInputChange={(event, newInputValue) => {
              setInputValueACCuentaBancaria(newInputValue);
            }}
            options={cuentasBancarias}
            renderInput={(params) => <TextField {...params} label="Cuenta Bancaria" />}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            disableClearable={true}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="comprobanteCuentaBancaria"
            label="Número de comprobante"
            variant="outlined"
            size="small"
            name="comprobanteCuentaBancaria"
            value={comprobanteCuentaBancaria}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="importe"
            label="Importe"
            variant="outlined"
            size="small"
            name="importe"
            value={importe.toLocaleString(
              settings.numericLocales.language,
              settings.numericLocales.options
            )}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
              style: { textAlign: "right" },
            }}
          />
          <Tooltip title="asignar el resto a cobrar">
            <Fab
              sx={{ ml: 1, mr: 1 }}
              color="secondary"
              aria-label="add"
              size="small"
              onClick={asignaRestoACobrar}
            >
              <PriceChangeOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>

        <Box sx={{ p: 1 }}>
          <Tooltip title="agregar cobranza">
            <Fab
              sx={{ mr: 1 }}
              color="primary"
              aria-label="add"
              size="small"
              onClick={actualizaCobro}
            >
              <CheckOutlinedIcon />
            </Fab>
          </Tooltip>

          <Tooltip title="cancelar">
            <Fab
              sx={{ mr: 1 }}
              color="outlined"
              aria-label="add"
              size="small"
              onClick={cancelaCobro}
            >
              <CloseOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>
      </Paper>
    </>
  );
};

export default CobroTransferenciaBancaria;
